import { Routes, Route } from "react-router-dom";
import MainPage from "./components/MainPage";

const App = () => {
  return (
    <Routes>
      <Route path="/:slug?" element={<MainPage />} />
    </Routes>
  );
};

export default App;
